import React, { memo, useCallback, useState } from 'react';
import cn from 'classnames';

import { DynamicIconWrapper, Icons, Modal } from '@components/common';
import FileTypeSelectionForm from '@components/common/FileTypeSelectionForm';

import { THandleExport } from '@components/common/FileTypeSelectionForm/FileTypeSelectionForm.types';

import { exportDashboardPORadioButtonsData } from '@constants/common';
import { MODAL_WIDTH_455 } from '@constants/modals';

import styles from './DashboardPOWhiteCard.module.scss';

interface IDashboardPOWhiteCard {
	children: React.ReactNode;
	title: string;
	isWithExport?: boolean;
	handleExport?: (data?: any) => void;
	outerProps?: Record<string, any>;
	className?: string;
}

const DashboardPOWhiteCard = ({
	children,
	title,
	isWithExport = false,
	handleExport,
	className,
}: IDashboardPOWhiteCard) => {
	const [isOpenFileTypeSelectionModal, setIsOpenFileTypeSelectionModal] = useState(false);

	const openFileTypeSelectionModal = useCallback(() => setIsOpenFileTypeSelectionModal(true), []);
	const closeFileTypeSelectionModal = useCallback(() => setIsOpenFileTypeSelectionModal(false), []);
	const toggleModal = useCallback(() => setIsOpenFileTypeSelectionModal((prev) => !prev), []);

	const wrapperClasses = cn(styles.whiteCardWrapper, className);

	return (
		<div className={wrapperClasses}>
			<div className={styles.whiteCardTitleWrapper}>
				<span className={styles.whiteCardTitle}>{title}</span>
				{isWithExport && (
					<DynamicIconWrapper
						icon={Icons.export}
						onClick={openFileTypeSelectionModal}
						tooltipLabel='Export'
					/>
				)}
			</div>
			<Modal
				isOpen={isOpenFileTypeSelectionModal}
				onClose={closeFileTypeSelectionModal}
				title='File extension to export'
				width={MODAL_WIDTH_455}
			>
				<FileTypeSelectionForm
					closeModals={closeFileTypeSelectionModal}
					exportRadioButtonsData={exportDashboardPORadioButtonsData}
					handlePreparingExport={handleExport as THandleExport}
					toggleModal={toggleModal}
				/>
			</Modal>
			{children}
		</div>
	);
};

export default memo(DashboardPOWhiteCard);
